import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import OneOutlookSuiteHeaderState from './schema/OneOutlookSuiteHeaderState';

var initialStore: OneOutlookSuiteHeaderState = {
    maximized: new ObservableMap<string, boolean>(),
};

export default createStore<OneOutlookSuiteHeaderState>('oneOutlookSuiteHeader', initialStore);
